/**
 * Rate Review Constants
 * @module RateReviewConstants
 */
export const RATE_REVIEW_CONSTANTS = {
  LEAD_SOURCE: "Rate Review",
  ZOHO_MODULE: "Leads",
  INITIAL_STATUS: "Review Info Received",
  DEFAULT_LEAD_STATUS: "Review Info Received",
  DEFAULT_NOTES: "Form Type: Rate Review",
  AVAILABLE_STATUSES: [
    "Review Info Received",
    "Review Being Analyzed",
    "Calculating Savings",
    "Schedule a Call to discuss",
  ],
  STATUS_CLASSES: {
    "Review Info Received": "text-bg-info",
    "Review Being Analyzed": "text-bg-info",
    "Calculating Savings": "text-bg-info",
    "Schedule a Call to discuss": "text-bg-success",
  },
  DEFAULT_STATUS_CLASS: "text-bg-secondary",
  STATUS_STEPS: [
    { value: "Review Info Received", label: "Review Info Received" },
    { value: "Review Being Analyzed", label: "Review Being Analyzed" },
    { value: "Calculating Savings", label: "Calculating Savings" },
    { value: "Schedule a Call to discuss", label: "Schedule a Call" },
  ],
  COUNTRIES: ["USA", "Canada"],
  DEFAULT_COUNTRY: "USA",
  DEFAULT_PAGE: 1,
  DEFAULT_PER_PAGE: 10,
  MAX_PER_PAGE: 50,
  MIN_PER_PAGE: 1,
  TABLE_HEADERS: [
    "Business Name",
    "Name",
    "Email",
    "Phone",
    "Gateway ID",
    "Date Submitted",
    "Status",
  ],
  DATE_SUBMITTED_COLUMN_INDEX: 5,
  SEARCH_LABEL: "Search Business Name, Name, or Email",
  SCROLL_LOAD_THRESHOLD: 200,
  ZOOM_MEETING: {
    DEFAULT_DURATION: 40,
    TIMEZONE: "America/New_York",
    MINUTE_STEP: 15,
  },
  DATE_FORMAT: "YYYY-MM-DD",
  DATE_TIME_FORMAT: "YYYY-MM-DD HH:mm",
  DISPLAY_DATE_FORMAT: "MMMM D, YYYY",
  DISPLAY_DATE_TIME_FORMAT: "MMMM D, YYYY [at] h:mm A",
  DATE_PRESET_LABELS: {
    today: "Today",
    yesterday: "Yesterday",
    week_to_date: "Week To Date",
    month_to_date: "Month To Date",
    year_to_date: "Year To Date",
    last_week: "Last Week",
    last_month: "Last Month",
    last_year: "Last Year",
    last7days: "Last 7 Days",
    last30days: "Last 30 Days",
    thisMonth: "This Month",
    lastMonth: "Last Month",
    thisYear: "This Year",
  },
  MAX_PROCESSING_STATEMENTS_FILES: 5,
  MAX_FILE_SIZE: 10 * 1024 * 1024,
  ALLOWED_FILE_TYPES: [
    "application/pdf",
    "image/jpeg",
    "image/jpg",
    "image/png",
  ],
  ALLOWED_FILE_EXTENSIONS: [".pdf", ".jpg", ".jpeg", ".png"],
  SALES_REP_DROPDOWN_MIN_CHARS: 3,
  GATEWAY_ID_LENGTH: 7,
  PHONE_NUMBER_LENGTH: 10,
  MAX_NOTES_LENGTH: 2000,
  EMAIL_TYPES: {
    MERCHANT_CONFIRMATION: "Merchant confirmation",
    MERCHANT_UPDATE: "Merchant update notification",
    SALES_REP_NOTIFICATION: "Sales rep notification",
    SALES_REP_UPDATE: "Sales rep update notification",
  },
  BUTTON_COLORS: {
    PRIMARY: "#52c41a",
    SECONDARY: "#2e8534",
  },
  UI_UPDATE_DELAY_MS: 500,
  DROPDOWN_INTERACTION_DELAY_MS: 100,
  BLUR_HANDLER_DELAY_MS: 200,
};

export default RATE_REVIEW_CONSTANTS;
